import { SfFileUploadFormField } from "ngx-smart-form";
import { ExtendedField } from "./cms-field";
import { IFormField } from "ngx-smart-form/lib/smart-form/interfaces/i-form-field";

export class CategoryUploadField<D = any> extends SfFileUploadFormField<D> {
  category?: string;

  constructor(data: ExtendedField
  ) {
    super({
        ...data as IFormField<D>,
        uploadLabel: 'Trascina o carica'
    } );
    if (data.category) {
      this.category = data.category;
    }   
  }
}